import joinClassNames from './joinClassNames.js'
import { BUTTON_VARIANT_CLASS } from './buttonVariantClass.js'

/**
 * @param {import('./index.d.ts').ButtonProps} props
 */
export default function Button({ className = '', variant, type = 'button', ...props }) {
  const variantClass = variant ? BUTTON_VARIANT_CLASS[variant] ?? '' : ''
  return (
    <button
      type={type}
      className={joinClassNames(variantClass, className)}
      {...props}
    />
  )
}
